module.exports = __webpack_public_path__ + "static/img/login.ddc9a2c0.gif";